import React from "react";
import imageData from "../../json/containerone";
import {
  Parallax,
  ParallaxBanner,
  ParallaxBannerLayer,
  ParallaxProvider,
} from "react-scroll-parallax";
import "./style/oneImage.css";
import { useNavigate } from "react-router-dom";

const MainImageContainer = () => {
  const navigate = useNavigate();
  let oneText = "";
  let btnstyle = "btn-style";
  let oneTextdec = "";
  if (imageData[0].position === "center") {
    oneText +=
      "text-5xl md:text-6xl p-10 md:p-0 text-white mb-5 font-semibold capitalize";
    btnstyle += " bg-white px-10 py-3 mx-auto";
    oneTextdec +=
      "text-sm text-white mx-auto my-5 tracking-wider font-semibold w-96 leading-loose sm:w-none md:w-96";
      btnstyle += " bg-white m-10 px-10 py-3 ";
  }
  return (
    <ParallaxProvider>
      <div>
        {imageData?.map((x,i) => (
          <ParallaxBanner
            style={{ aspectRatio: "2 / 1", height: "100vh" }}
            className="aspect-[2/1] parallax-container relative"
            key={i}
          >
            <ParallaxBannerLayer
              image={x.img}
              speed={-20}
              // translateY={(-20)}
              style={{ width: "100%", backgroundPosition: "center" }}
            />
            <Parallax className="relative h-full">
              <div className={`one-text-image text-center`}>
                <p className={`${oneText} pacifico-regular`}>{x.name}</p>
                <p className={`${oneTextdec}`}>{x.dec}</p>
                <div className={`btnstyle1`}>
                  <span
                    onClick={() => navigate("/category")}
                    className={`${btnstyle} cursor-pointer `}
                  >
                    {x.btn}
                  </span>
                </div>
              </div>
            </Parallax>
          </ParallaxBanner>
        ))}
      </div>
    </ParallaxProvider>
  );
};

export default MainImageContainer;
